<template>
  <RfInput
    :modelValue="modelValue"
    type="number"
    variant="outlined"
    autoWidth
    :title="title"
    :disabled="disabled"
    v-bind="$attrs"
    @update:modelValue="onInput"
  >
    <template #prepend>
      <RfButtonNew
        type="table"
        class="my-1"
        :disabled="disabled || (modelValue <= min ? minMessage : null)"
        @click.prevent="change(-step)"
      >
        <span class="m-auto flex h-6 w-6 items-center justify-center text-base">−</span>
      </RfButtonNew>
    </template>
    <template #append>
      <RfButtonNew type="table" :disabled="disabled" class="my-1" @click.prevent="change(step)">
        <span class="m-auto flex h-6 w-6 items-center justify-center text-base">+</span>
      </RfButtonNew>
      <span v-if="unitLabel" class="text-body text-grey-1 ml-2">{{ unitLabel }}</span>
    </template>
  </RfInput>
</template>

<script setup>
import { computed } from "vue";
import RfInput from "@/components/inputs/RfInput.vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  modelValue: { type: Number, default: 0 },
  title: { type: String, default: "" },
  unit: { type: [String, Function], default: "" },
  min: { type: Number, default: 0 },
  minMessage: { type: String, default: "" },
  step: { type: Number, default: 1 },
  disabled: { type: Boolean, default: false },
});
const emit = defineEmits(["update:modelValue"]);

const unitLabel = computed(() =>
  typeof props.unit === "function" ? props.unit(props.modelValue) : props.unit,
);

const clamp = value => Math.max(value, props.min);

const onInput = val => {
  const num = Number(val);
  if (Number.isNaN(num)) return;
  emit("update:modelValue", clamp(num));
};

const change = delta => {
  const current = Number(props.modelValue);
  emit("update:modelValue", clamp((Number.isNaN(current) ? props.min : current) + delta));
};
</script>
